import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';
import loading from '@ms/yammer-web-components/dist/navigation/NavigationSpinner';

const homeLoader = () => import(/* webpackChunkName: "4-page-home" */ '../PageHome');
const inboxLoader = () => import(/* webpackChunkName: "4-page-inbox" */ '../PageInbox');
const groupLoader = () => import(/* webpackChunkName: "4-page-group" */ '../PageGroup');
const storylineHomeLoader = () => import(/* webpackChunkName: "4-page-storyline-home" */ '../PageStorylineHome');
const groupInsightsLoader = () =>
  import(/* webpackChunkName: "4-page-group-insights" */ '@ms/yammer-web-components/dist/group/PageGroupInsights');
const threadLoader = () => import(/* webpackChunkName: "4-page-thread" */ '../PageThread');
const userLoader = () => import(/* webpackChunkName: "4-page-user" */ '../PageUser');
const userInsightsLoader = () =>
  import(/* webpackChunkName: "4-page-user-insights" */ '@ms/yammer-web-components/dist/user/PageUserInsights');
const topicLoader = () => import(/* webpackChunkName: "4-page-topic" */ '../PageTopic');
const usagePolicyLoader = () => import(/* webpackChunkName: "4-page-usagepolicy" */ '../PageUsagePolicy');
const searchLoader = () => import(/* webpackChunkName: "4-page-search" */ '../PageSearch');
const liveEventLoader = () => import(/* webpackChunkName: "4-page-liveevent" */ '../PageLiveEvent');
const delegationSettingsLoader = () =>
  import(/* webpackChunkName: "4-page-delegation-settings" */ '../PageDelegationSettingsLifecycle');
const discoverGroupsLoader = () => import(/* webpackChunkName: "4-page-discover-groups" */ '../PageDiscoverGroups');
const logoutLoader = () => import(/* webpackChunkName: "4-page-logout" */ '../PageLogout');
const leadershipCornerLoader = () =>
  import(/* webpackChunkName: "4-page-leadershipcorner" */ '../PageLeadershipCorner');
const questionsLoader = () => import(/* webpackChunkName: "4-page-questions" */ '../PageQuestions');
const insightsQnALoader = () =>
  import(/* webpackChunkName: "4-page-insights-qna" */ '@ms/yammer-web-components/dist/insights/PageInsightsQnAMain');

const legacyRouteConverterLoader = () =>
  import(
    /* webpackChunkName: "4-page-legacyrouteconverter" */ '@ms/yammer-web-components/dist/route/LegacyRouteConverter'
  );
const legacyRouterLoader = () =>
  import(/* webpackChunkName: "4-page-legacyrouter" */ '@ms/yammer-web-components/dist/route/LegacyRouter');
const storylineRouterLoader = () =>
  import(/* webpackChunkName: "4-page-storylinerouter" */ '@ms/yammer-web-components/dist/route/StorylineRouter');

export const Home = lazyLoadOnRender({ loader: homeLoader, loading });
export const Inbox = lazyLoadOnRender({ loader: inboxLoader, loading });
export const Group = lazyLoadOnRender({ loader: groupLoader, loading });
export const StorylineHome = lazyLoadOnRender({ loader: storylineHomeLoader, loading });
export const GroupInsights = lazyLoadOnRender({ loader: groupInsightsLoader, loading });
export const Thread = lazyLoadOnRender({ loader: threadLoader, loading });
export const User = lazyLoadOnRender({ loader: userLoader, loading });
export const UserInsights = lazyLoadOnRender({ loader: userInsightsLoader, loading });
export const Topic = lazyLoadOnRender({ loader: topicLoader, loading });
export const UsagePolicy = lazyLoadOnRender({ loader: usagePolicyLoader, loading });
export const Search = lazyLoadOnRender({ loader: searchLoader, loading });
export const LiveEvent = lazyLoadOnRender({ loader: liveEventLoader, loading });
export const DelegationSettings = lazyLoadOnRender({ loader: delegationSettingsLoader, loading });
export const DiscoverGroups = lazyLoadOnRender({ loader: discoverGroupsLoader, loading });
export const Logout = lazyLoadOnRender({ loader: logoutLoader, loading });
export const LeadershipCorner = lazyLoadOnRender({ loader: leadershipCornerLoader, loading });
export const Questions = lazyLoadOnRender({ loader: questionsLoader, loading });
export const InsightsQnA = lazyLoadOnRender({ loader: insightsQnALoader, loading });

export const LegacyRouteConverter = lazyLoadOnRender({ loader: legacyRouteConverterLoader, loading });
export const LegacyRouter = lazyLoadOnRender({ loader: legacyRouterLoader, loading });
export const StorylineRouter = lazyLoadOnRender({ loader: storylineRouterLoader, loading });
